import { ResponsiveLine } from '@nivo/line';
import { nivoTheme } from '@shared/ui/nivoTheme';

// Brand mention trend — posts vs stories per month, as a Nivo stacked-area line with
// a crosshair slice on hover (lights up all series at the hovered month). Lazy-loaded.

interface Pt { month: string; posts: number; stories: number; }

const POSTS = '#4a9eff';
const STORIES = '#9B5DE5';

export default function BrandTrendNivo({ trend, lang, postsLabel, storiesLabel }: {
  trend: Pt[]; lang: string; postsLabel: string; storiesLabel: string;
}) {
  const months = trend.map((p) => new Date(p.month + 'T00:00:00').toLocaleDateString(lang, { month: 'short' }));
  const step = Math.max(1, Math.ceil(months.length / 6));
  const series = [
    { id: postsLabel, data: trend.map((p, i) => ({ x: months[i], y: p.posts })) },
    { id: storiesLabel, data: trend.map((p, i) => ({ x: months[i], y: p.stories })) },
  ];
  const chip = (c: string, label: string) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
      <span style={{ width: 9, height: 9, borderRadius: 2, background: c, display: 'inline-block' }} />{label}
    </span>
  );
  return (
    <div>
      <div style={{ height: 150 }}>
        <ResponsiveLine
          data={series}
          curve="monotoneX"
          colors={[POSTS, STORIES]}
          xScale={{ type: 'point' }}
          yScale={{ type: 'linear', min: 0, max: 'auto', stacked: true }}
          enableArea
          areaOpacity={0.85}
          defs={[
            { id: 'gp', type: 'linearGradient', x1: 0, y1: 0, x2: 0, y2: 1, colors: [{ offset: 0, color: POSTS, opacity: 0.55 }, { offset: 100, color: POSTS, opacity: 0.06 }] },
            { id: 'gs', type: 'linearGradient', x1: 0, y1: 0, x2: 0, y2: 1, colors: [{ offset: 0, color: STORIES, opacity: 0.55 }, { offset: 100, color: STORIES, opacity: 0.06 }] },
          ]}
          fill={[{ match: { id: postsLabel }, id: 'gp' }, { match: { id: storiesLabel }, id: 'gs' }]}
          lineWidth={1.6}
          enablePoints={false}
          enableGridX={false}
          gridYValues={4}
          margin={{ top: 10, right: 10, bottom: 24, left: 28 }}
          axisLeft={{ tickSize: 0, tickPadding: 6, tickValues: 4 }}
          axisBottom={{ tickSize: 0, tickPadding: 8, tickValues: months.filter((_, i) => i % step === 0) }}
          enableSlices="x"
          theme={nivoTheme}
          animate
        />
      </div>
      <div style={{ display: 'flex', gap: 12, fontSize: 'var(--fs-caption)', color: '#8a94a6', marginTop: 2 }}>
        {chip(POSTS, postsLabel)}
        {chip(STORIES, storiesLabel)}
      </div>
    </div>
  );
}
